import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { JezykInterceptor } from './core/interceptory/jezyk.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { WspolneModule } from './wspolne/wspolne.module';
import { StoreModule } from '@ngrx/store';
import { APP_BASE_HREF } from '@angular/common';


export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function getBaseHref(): string {
  if (window.location.hostname === 'localhost') {
    return '/';
  }
  return '/portal-historyczny/';
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HammerModule,
    HttpClientModule,
    StoreModule.forRoot({}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    WspolneModule,
  ],

  providers: [
    { provide: APP_BASE_HREF, useFactory: getBaseHref },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JezykInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
